import React, { useEffect } from 'react'
import { useCardStore } from './store/useCardStore'
import { TerminalCard } from './themes/TerminalCard'
import { NotionCard } from './themes/NotionCard'
import { VSCodeCard } from './themes/VSCodeCard'
import { Web3Card } from './themes/Web3Card'
import { CardEditor } from './components/CardEditor'
import { ThemeSelector } from './components/ThemeSelector'
import { ExportButtons } from './components/ExportButtons'

function App() {
  const { cardData } = useCardStore()

  const renderCard = () => {
    switch (cardData.theme) {
      case 'terminal':
        return <TerminalCard data={cardData} />
      case 'notion':
        return <NotionCard data={cardData} />
      case 'vscode':
        return <VSCodeCard data={cardData} />
      case 'web3':
        return <Web3Card data={cardData} />
      default:
        return <TerminalCard data={cardData} />
    }
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('message event received');
      // eslint-disable-next-line no-debugger
      debugger;
      console.log(':::data',event.data);
      console.log(':::origin',event.origin)
      // eslint-disable-next-line no-debugger
      debugger;
    }

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  },[])

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b shadow-sm">
        <div className="px-4 py-6 mx-auto max-w-7xl">
          <div className="text-center">
            <h1 className="mb-2 text-4xl font-bold text-gray-900">
              🧑‍💻 whoami
            </h1>
            <p className="text-lg text-gray-600">
              감성 있는 웹 명함 생성기
            </p>
            <p className="mt-1 text-sm text-gray-500">
              "명함 하나에도, 정체성이 담긴다."
            </p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 py-8 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* Left Side - Controls */}
          <div className="space-y-6">
            <CardEditor />
            <ThemeSelector />
            <ExportButtons />
          </div>

          {/* Right Side - Preview */}
          <div className="lg:sticky lg:top-8 lg:self-start">
            <div className="mb-6 text-center">
              <h2 className="mb-2 text-2xl font-bold text-gray-800">
                ✨ 미리보기
              </h2>
              <p className="text-gray-600">
                실시간으로 변경사항을 확인하세요
              </p>
            </div>
            
            <div className="flex justify-center">
              <div id="card-preview" className="inline-block">
                {renderCard()}
              </div>
            </div>

            {/* Tips */}
            <div className="p-4 mt-6 rounded-lg bg-blue-50">
              <h3 className="mb-2 font-semibold text-blue-800">💡 사용 팁</h3>
              <ul className="space-y-1 text-sm text-blue-700">
                <li>• 테마를 바꿔가며 다양한 스타일을 체험해보세요</li>
                <li>• 복사 버튼으로 GitHub README나 SNS에 붙여넣기 가능</li>
                <li>• PNG/JPG 다운로드로 이미지 파일로 저장하세요</li>
                <li>• 이모지를 활용해서 더 감성적으로 꾸며보세요</li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-12 bg-white border-t">
        <div className="px-4 py-6 mx-auto max-w-7xl">
          <div className="text-center text-gray-600">
            <p>
              Made with 💚 by{' '}
              <a 
                href="https://github.com/hazzzi" 
                className="text-blue-600 hover:underline"
                target="_blank" 
                rel="noopener noreferrer"
              >
                hazzzi
              </a>
            </p>
          </div>
        </div>
      </footer>

      <iframe 
        src="https://hazzzi.github.io/undo-list"
        title="Undo List"
        className="w-full max-w-md mt-6 border-2 rounded-lg shadow-lg h-96 sm:mt-8 border-white/20"
        style={{ backdropFilter: 'blur(10px)' }}
      />
    </div>
  )
}

export default App 